import { useTheme } from "@mui/material/styles";

import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";

import numbers from "core/numbers";
import dates from "core/dates";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Button from "ui/base/Button";


DepositList.Row = ({ deposit, loading }) => {
	const style = {
		tokens: { alignItems: "center" }
	};

	if (loading) return (
		<TableRow>
			<TableCell><Skeleton width="80px" /></TableCell>
			<TableCell>
				<Box gap={0.5} sx={style.tokens}>
					<Icon.Coin size={16} /> <Skeleton width="40px" />
				</Box>
			</TableCell>
			<TableCell><Skeleton width="100px" /></TableCell>
			<TableCell><Skeleton width="20px" height="20px" /></TableCell>
		</TableRow>
	);
	return (
		<TableRow>
			<TableCell>{numbers.format(deposit.amount, "currency", { decimals: 2 })}</TableCell>
			<TableCell>
				<Box gap={0.5} sx={style.tokens}>
					<Icon.Coin size={16} /> {deposit.tokens}
				</Box>
			</TableCell>
			<TableCell>{dates.brief(deposit.date)}</TableCell>
			<TableCell>
				<Button.Icon icon="receipt" size="20px" href={deposit.receiptUrl} target="_blank" disabled={!deposit.receiptUrl} />
			</TableCell>
		</TableRow>
	);
};

export default function DepositList({ data, page, count, take, setPage, loading }) {
	const theme = useTheme();
	const rows = loading ? Array.from({ length: take }, (_, i) => i) : data;
	const fill = take - rows?.length;

	const headers = ["Amount", "Tokens", "Date", "Receipt"];
	const style = {
		table: {
			"th, td": {
				p: theme.spacing(0.75, 1.25)
			}
		},
		head: { fontWeight: 700 },
		pagination: { pt: `${fill * 49}px` }
	};

	if (data?.length === 0) return <Typography variant="h4" textAlign="center">Nothing purchased so far.</Typography>;
	return (
		<>
			<TableContainer component={Paper}>
				<Table size="small" sx={style.table}>
					<TableHead>
						<TableRow>
							{headers.map((h, k) => <TableCell sx={style.head} key={k}>{h}</TableCell>)}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((deposit, k) => <DepositList.Row key={k} deposit={deposit} loading={loading} />)}
					</TableBody>
				</Table>
			</TableContainer>
			{!loading && page && <Pagination siblingCount={0} page={page} count={count} color="secondary" onChange={(_, p) => setPage(p)} sx={style.pagination} />}
		</>
	);
}